import { render, staticRenderFns } from "./SvgIconComponent.vue?vue&type=template&id=d21075c0"
import script from "./SvgIconComponent.vue?vue&type=script&lang=js"
export * from "./SvgIconComponent.vue?vue&type=script&lang=js"
import style0 from "./SvgIconComponent.vue?vue&type=style&index=0&id=d21075c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports